import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BlockParameter } from '../../../../models/block';

@Component
class BlockGridConditions extends Vue {

  @Prop({ required: false, default: null, type: [String] })
  title: string;
  @Prop({ required: false, default: null, type: [String] })
  blockName: string | null;

  @Prop({ required: true, type: [Object] })
  parameter: BlockParameter;

  @Prop({ default: true, type: Boolean })
  showSort: boolean;



  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get sortValues(): number[] {
    return this.parameter.orderValues;
  }
  set sortValues(val: number[]) {
    this.$emit('update:parameter', { ...this.parameter, orderValues: val, $skip: 0 });
  }

}

export default BlockGridConditions;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-conditions/index.ts